import {createCrud} from "./CRUD";

const initialState = { items: [], item: {} };

let {constants, actions, reducer} =
    createCrud(
        '/main/opportunity-company-document/',
        'OpportunityCompanyDocument',
        'OpportunityCompanyDocuments',
        initialState);

export const opportunityCompanyDocumentConstants = constants;
export const opportunityCompanyDocumentActions = actions;
export const opportunityCompanyDocumentReducer = reducer;
